import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'academics-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './academics-menu.component.html',
  styleUrls: ['./academics-menu.component.css'],
})
export class AcademicsMenuComponent {

}
